import Vue from 'vue'

const DB_KEY = '588c5022f08c28a0bd3ed05f9c496bb469702606'

const db = new Vue({
  data: {
    lang: 'zh',
    user: null,
    from_url: null
  },
  created () {
    const data = window.localStorage.getItem(DB_KEY)
    if (data != null) {
      Object.assign(this.$data, JSON.parse(data))
    }
  }
})

db.$watch(
  '$data',
  function cb () {
    window.localStorage.setItem(DB_KEY, JSON.stringify(this.$data))
  },
  {
    deep: true,
    immediate: true
  }
)

export default db
